var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnreal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 20,
    role: "img",
    "aria-label": "Unreal Engine",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unreal Engine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 105,
    height: 20,
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPlVucmVhbCBFbmdpbmU8L3RpdGxlPjxwYXRoIGQ9Ik0xMiAwYTEyIDEyIDAgMTAxMiAxMkExMiAxMiAwIDAwMTIgMHptMCAyMy41MkExMS41MiAxMS41MiAwIDExMjMuNTIgMTIgMTEuNTIgMTEuNTIgMCAwMTEyIDIzLjUyem03LjEzLTkuNzkxYy0uMjA2Ljk5Ny0xLjEyNiAzLjU1Ny00LjA2IDQuOTQybC0xLjE3OS0xLjMyNS0xLjk4OCAyYTcuMzM4IDcuMzM4IDAgMDEtNS44MDQtMi45NzggMi44NTkgMi44NTkgMCAwMC42NS4xMjNjLjMyNi4wMDYuNjc4LS4xMTQuNjc4LS42NnYtNS4zOTRhLjg5Ljg5IDAgMDAtMS4xMTYtLjg5Yy0uOTIuMjEyLTEuNjU2IDIuNTA5LTEuNjU2IDIuNTA5YTcuMzA0IDcuMzA0IDAgMDEyLjUyOC01LjU5NyA3LjQwOCA3LjQwOCAwIDAxMy43My0xLjcyMWMtMS4wMDYuNTczLTEuNTcgMS41MDctMS41NyAyLjI5IDAgMS4yNjIuNzYgMS4xMDkuOTg0LjkyM3Y3LjI4YTEuMTU3IDEuMTU3IDAgMDAuMTQ4LjI1NiAxLjA3NSAxLjA3NSAwIDAwLjg4LjQ0NWMuNzYgMCAxLjc0Ny0uODY4IDEuNzQ3LS44NjhWOS4xNzJjMC0uNi0uNDUyLTEuMzI0LS45MDUtMS41NzIgMCAwIC44MzgtLjE0OSAxLjQ4NC4zNDZhNS41MzcgNS41MzcgMCAwMS4zODctLjQyNWMxLjUwOC0xLjQ4IDIuOTI5LTEuOTAyIDQuMTEyLTIuMTEyIDAgMC0yLjE1MSAxLjY5LTIuMTUxIDMuOTYgMCAxLjY4Ny4wNDMgNS44MDEuMDQzIDUuODAxLjc5OS43NzEgMS45ODYtLjM0MiAzLjA1OS0xLjQ0MVoiLz48L3N2Zz4="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 615,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 770
  }, "Unreal Engine"), /*#__PURE__*/React.createElement("text", {
    x: 615,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 770
  }, "Unreal Engine"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreal);
export default __webpack_public_path__ + "static/media/unreal.e85fc7bef1ed14346d7b6f04b5d9ba52.svg";
export { ForwardRef as ReactComponent };